import isAppAllowedByPartner from './is-app-allowed-by-partner';

export default {
  isAppAllowedByPartner,
};
